import { get } from "lodash";

const styles = (theme) => ({
  editorContainer: {
    position: "relative",
  },
  editorFontType: {
    background: get(theme, 'color.uiBackground'),
    border: `2px solid ${get(theme, 'color.borderColor')}`,
    borderRadius: 3,
    color: get(theme, 'color.primaryButtonBackground'),
    width: 40,
    height: 40,
    padding: 3,
    boxSizing: 'border-box',
  },
  editorFontFamily: {
    border: `2px solid ${get(theme, 'color.borderColor')}`,
    borderRadius: 3,
    color: get(theme, 'color.primaryButtonBackground'),
    fontFamily: get(theme, 'typography.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
    margin: 0,
    width: 180,
    height: 40,
    padding: '0px 10px',
    boxSizing: 'border-box',
    '& .rdw-dropdownoption-default': {
      color: get(theme, 'color.bodyText'),
      padding: '7.5px 12px 7.5px 16px',
    },
  },
  editorFontSize: {
    width: 95,
    height: 40,
    padding: '0px 10px',
    boxSizing: 'border-box',
    border: `1px solid ${get(theme, 'color.borderColor')}`,
    borderRadius: 5,
  },
  editorLink: {
    border: `1px solid ${get(theme, 'color.borderColor')}`,
    borderRadius: 5,
    boxSizing: 'border-box',
    fontFamily: get(theme, 'typography.bodyText'),
    '& button': {
      minWidth: 38,
      width: 38,
      height: 38,
      borderColor: '#fff',
      borderRadius: 5,
      padding: 5,
    },
    height: 40,
    position: 'static',
    width: 40,
  },
  editor: {
    backgroundColor: get(theme, 'color.uiBackground'),
    border: `1px solid ${get(theme, 'color.borderColor')}`,
    borderRadius: 3,
    fontSize: 14,
    width: '100%',
    height: 131,
    paddingLeft: 13,
    paddingRight: 13,
  },
  editorWrapper: {
    backgroundColor: 'transparent',
    border: 0,
    padding: 0,
  },
  restoreDefaultButton: {
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
    position: "absolute",
    top: 6,
    right: 10,
  },
  helperText: {
    color: `${get(theme, 'color.smallText')} !important`,
    fontFamily: `${get(theme, 'typography.smallText')} !important`,
    fontSize: `${get(theme, 'fontSize.smallText')} !important`,
  },
})

export default styles;